import * as ReactDOM from 'react-dom/client';
import createAppRoot from './main';
import { routerConfig } from './app/routes';
import { Router } from 'wouter';
import initSentry from './app/sentry/sentry-client';
import { initMixpanel } from './app/analytics/mixpanel';
import { initHotjar } from './app/analytics/hotjar';

initMixpanel();

if (import.meta.env.VITE_ANALYTICS_ENABLED === 'true') {
  initHotjar();
}

if (import.meta.env.VITE_SENTRY_ENABLED === 'true') {
  initSentry();
}

ReactDOM.hydrateRoot(
  document.getElementById('root') as HTMLDivElement,
  <Router base='/platform'>{createAppRoot(routerConfig)}</Router>,
);
